import React from "react";
import { EstadoContenido } from "../../../../utils/constants";
import { ConfiguracionLogosPage } from "..";

const LogosEnRevisionPage = () => (
  <ConfiguracionLogosPage estado={EstadoContenido.EnRevision} />
);

export default LogosEnRevisionPage;
